import { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { Lightbulb, Crosshair, TrendingUp, Target, Layers } from 'lucide-react';

const API_BASE = '';

const INSIGHT_CONFIG = [
  { key: 'tactical_analysis', icon: Crosshair, title: 'Tactical Analysis', color: 'violet' },
  { key: 'key_players_impact', icon: Lightbulb, title: 'Key Players', color: 'amber' },
  { key: 'odds_movement_analysis', icon: TrendingUp, title: 'Odds Movement', color: 'emerald' },
  { key: 'match_scenario', icon: Target, title: 'Match Scenario', color: 'blue' },
  { key: 'betting_angle', icon: Layers, title: 'Market Angle', color: 'cyan' },
];

export default function MatchInsights({ slug }) {
  const [data, setData] = useState(null);
  const { currentLang } = useLanguage();
  const { t } = useTranslation();

  useEffect(() => {
    if (!slug) return;
    fetch(`${API_BASE}/api/seo/match/${slug}/insights?lang=${currentLang}`)
      .then(r => r.json())
      .then(d => setData(d?.insights || d))
      .catch(() => {});
  }, [slug, currentLang]);

  if (!data) return null;

  const visible = INSIGHT_CONFIG.filter(c => data[c.key] && data[c.key].trim().length >= 20);
  if (visible.length === 0) return null;

  const colors = {
    violet: 'border-violet-500/20 bg-violet-500/5 text-violet-400',
    amber: 'border-amber-500/20 bg-amber-500/5 text-amber-400',
    emerald: 'border-emerald-500/20 bg-emerald-500/5 text-emerald-400',
    blue: 'border-blue-500/20 bg-blue-500/5 text-blue-400',
    cyan: 'border-cyan-500/20 bg-cyan-500/5 text-cyan-400',
  };

  return (
    <div className="mb-6" data-testid="match-insights">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {visible.map(c => {
          const Icon = c.icon;
          const cls = colors[c.color] || colors.violet;
          return (
            <div key={c.key} className={`border rounded-xl p-4 ${cls.split(' ').slice(0, 2).join(' ')}`} data-testid={`insight-${c.key}`}>
              <div className="flex items-center gap-2 mb-2">
                <Icon className={`w-4 h-4 ${cls.split(' ').pop()}`} />
                <h4 className={`text-xs font-semibold uppercase tracking-wider ${cls.split(' ').pop()}`}>{c.title}</h4>
              </div>
              <p className="text-xs text-slate-400 leading-relaxed">{data[c.key]}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
